// Set the sale end date/time (adjust this date/time as needed)
var saleEndDate = new Date("2025-03-13T23:59:59").getTime();

// Update the countdown every second
var countdownInterval = setInterval(function() {
  var now = new Date().getTime();
  var distance = saleEndDate - now;

  // Calculate days, hours, minutes, seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Get the HTML elements
  var daysEl = document.getElementById("header-days");
  var hoursEl = document.getElementById("header-hours");
  var minutesEl = document.getElementById("header-minutes");
  var secondsEl = document.getElementById("header-seconds");

  // Only update the elements if they exist
  if (daysEl && hoursEl && minutesEl && secondsEl) {
    daysEl.textContent = days;
    hoursEl.textContent = hours;
    minutesEl.textContent = minutes;
    secondsEl.textContent = seconds;
  }

  // If the countdown is finished, clear the interval and hide the banner if it exists
  if (distance < 0) {
    clearInterval(countdownInterval);
    var banner = document.querySelector(".announcement-banner");
    if (banner) {
      banner.style.display = "none";
    }
  }
}, 1000);
